const sort = (a, b) => {
  if (a.display < b.display) {
    return -1;
  }
  if (a.display > b.display) {
    return 1;
  }
  return 0;
};

const sortAndFilter = (objects) =>
  objects
    .sort((a, b) => sort(a, b))
    .filter(
      (obj, pos, arr) => arr.map((mapObj) => mapObj.id).indexOf(obj.id) === pos
    );

export default sortAndFilter;
